import { render, staticRenderFns } from "./Ordersub.vue?vue&type=template&id=4c387ec4&scoped=true"
import script from "./Ordersub.vue?vue&type=script&lang=js"
export * from "./Ordersub.vue?vue&type=script&lang=js"
import style0 from "./Ordersub.vue?vue&type=style&index=0&id=4c387ec4&prod&scoped=true&lang=css"
import style1 from "./Ordersub.vue?vue&type=style&index=1&id=4c387ec4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c387ec4",
  null
  
)

export default component.exports